import { mapGetters, mapActions, mapMutations } from "vuex";
import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";
import catalogProduct from "@/components/catalog-product/index.vue";

export default {
    name: "top-products",
    components: {
        VueAdsPagination,
        VueAdsPageButton,
        catalogProduct,
    },
    data() {
        return {
            page: 0,
        };
    },
    computed: {
        ...mapGetters({
            listTopProducts: "topProducts/list",
            listLengthProducts: "topProducts/listLength",
            skip: "topProducts/skip",
            reviewListLoading: "topProducts/reviewListLoading",
            limit: "topProducts/limit",
            item: "topProducts/list",
        }),
    },
    watch: {
        $route() {
            this.page = 0;
            this.fetchList();
        },
    },
    created() {
        this.fetchList();
    },
    methods: {
        ...mapActions({
            fetchList: `topProducts/GET_PRODUCTS_TOP_LIST`,
            fetchReviews: `card/GET_PRODUCT_REVIEWS`,
        }),
        ...mapMutations({
            changePage: `topProducts/CHANGE_SKIP_TOP_LIST`,
            resetProduct: `card/RESET_PRODUCT`,
        }),
        changePageLocal(page) {
            this.page = page;
            this.changePage(page + 1);
            this.fetchList();
            window.scrollTo({
                behavior: "smooth",
                top: 0,
            });
        },
    },
};
